(function () {
    'use strict';

    if (window.MetodoBluChlorineCalculatorInitialized) return;
    window.MetodoBluChlorineCalculatorInitialized = true;

    var STORAGE_KEY_PREFIX = 'chlorine-calculator';

    function getNumber(value) {
        var normalized = String(value).trim().replace(',', '.');
        var parsed = parseFloat(normalized);
        return isNaN(parsed) ? null : parsed;
    }

    function formatNumber(value, decimals) {
        if (value === null || typeof value === 'undefined' || isNaN(value)) return '—';
        var fixed = value.toFixed(decimals);
        return fixed.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
    }

    function formatMessage(template, replacements) {
        return String(template || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_, token) {
            return Object.prototype.hasOwnProperty.call(replacements, token) ? replacements[token] : '';
        });
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function decodeHtmlEntities(value) {
        if (!value) return value;
        var parser = document.createElement('textarea');
        parser.innerHTML = value;
        return parser.value;
    }

    function convertVolumeForDose(volumeM3, volumeUnit) {
        var normalizedUnit = String(volumeUnit || 'm3').toLowerCase();
        if (normalizedUnit === 'l' || normalizedUnit === 'lt' || normalizedUnit === 'liter' || normalizedUnit === 'liters' || normalizedUnit === 'litre' || normalizedUnit === 'litres') {
            return volumeM3 * 1000;
        }
        return volumeM3;
    }

    function calcVolume(state) {
        var depth = state.depth;
        if (!depth || depth <= 0) return 0;

        if (state.shape === 'rectangular') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return state.length * state.width * depth;
        }

        if (state.shape === 'oval') {
            if (!state.length || !state.width || state.length <= 0 || state.width <= 0) return 0;
            return (Math.PI / 4) * state.length * state.width * depth;
        }

        if (state.shape === 'circular') {
            if (!state.diameter || state.diameter <= 0) return 0;
            return (Math.PI / 4) * state.diameter * state.diameter * depth;
        }

        if (state.shape === 'custom') {
            if (!state.surface || state.surface <= 0) return 0;
            return state.surface * depth;
        }

        return 0;
    }

    document.querySelectorAll('[data-clc-root]').forEach(function (root, rootIndex) {
        var shapeInputs = root.querySelectorAll('[data-clc-shape]');
        var inputEls = root.querySelectorAll('[data-clc-input]');
        var volumePreview = root.querySelector('[data-clc-volume-preview]');
        var volumeDisplay = root.querySelector('[data-clc-volume-display]');
        var resultsContainer = root.querySelector('[data-clc-results]');
        var storageKey = STORAGE_KEY_PREFIX + ':' + window.location.pathname + ':' + rootIndex;

        var config = {
            ready: root.getAttribute('data-clc-config-ready') === 'true',
            hasDose: root.getAttribute('data-clc-has-dose') === 'true',
            hasPpm: root.getAttribute('data-clc-has-ppm') === 'true',
            hasMaintenance: root.getAttribute('data-clc-has-maintenance') === 'true',
            hasShock: root.getAttribute('data-clc-has-shock') === 'true',
            // dose
            doseAmount: getNumber(root.getAttribute('data-clc-dose-amount')) || 0,
            doseUnit: root.getAttribute('data-clc-dose-unit') || 'tablet',
            dosePpmChange: getNumber(root.getAttribute('data-clc-dose-ppm-change')) || 0,
            dosePerVolume: getNumber(root.getAttribute('data-clc-dose-per-volume')) || 0,
            doseVolumeUnit: root.getAttribute('data-clc-dose-volume-unit') || 'm3',
            // maintenance
            maintAmount: getNumber(root.getAttribute('data-clc-maint-amount')) || 0,
            maintUnit: root.getAttribute('data-clc-maint-unit') || 'tablet',
            maintPerVolume: getNumber(root.getAttribute('data-clc-maint-per-volume')) || 0,
            maintVolumeUnit: root.getAttribute('data-clc-maint-volume-unit') || 'm3',
            maintInterval: root.getAttribute('data-clc-maint-interval') || 'weekly',
            // shock
            shockAmount: getNumber(root.getAttribute('data-clc-shock-amount')) || 0,
            shockUnit: root.getAttribute('data-clc-shock-unit') || 'tablet',
            shockPerVolume: getNumber(root.getAttribute('data-clc-shock-per-volume')) || 0,
            shockVolumeUnit: root.getAttribute('data-clc-shock-volume-unit') || 'm3',
            // i18n
            doseTitleText: decodeHtmlEntities(root.getAttribute('data-clc-i18n-dose-title')) || '',
            maintenanceTitleText: decodeHtmlEntities(root.getAttribute('data-clc-i18n-maintenance-title')) || '',
            shockTitleText: decodeHtmlEntities(root.getAttribute('data-clc-i18n-shock-title')) || '',
            doseTemplate: decodeHtmlEntities(root.getAttribute('data-clc-i18n-dose-template')) || 'To reach {{ target }} ppm, add {{ amount }} {{ unit }}.',
            doseFlatTemplate: decodeHtmlEntities(root.getAttribute('data-clc-i18n-dose-flat-template')) || 'Add {{ amount }} {{ unit }}.',
            maintenanceTemplate: decodeHtmlEntities(root.getAttribute('data-clc-i18n-maintenance-template')) || 'Add {{ amount }} {{ unit }} {{ interval }}.',
            shockTemplate: decodeHtmlEntities(root.getAttribute('data-clc-i18n-shock-template')) || 'For shock treatment, add {{ amount }} {{ unit }}.',
            alreadyInRange: decodeHtmlEntities(root.getAttribute('data-clc-i18n-already-in-range')) || 'The chlorine level is already at the desired level.',
            missingConfiguration: decodeHtmlEntities(root.getAttribute('data-clc-i18n-missing-configuration')) || 'This product is missing the dosing configuration.',
            intervalLabels: {
                daily: decodeHtmlEntities(root.getAttribute('data-clc-i18n-interval-daily')) || 'daily',
                weekly: decodeHtmlEntities(root.getAttribute('data-clc-i18n-interval-weekly')) || 'weekly',
                biweekly: decodeHtmlEntities(root.getAttribute('data-clc-i18n-interval-biweekly')) || 'every two weeks',
                monthly: decodeHtmlEntities(root.getAttribute('data-clc-i18n-interval-monthly')) || 'monthly'
            },
            unitLabels: {
                tablet: decodeHtmlEntities(root.getAttribute('data-clc-i18n-unit-tablet')) || 'tablet',
                tablets: decodeHtmlEntities(root.getAttribute('data-clc-i18n-unit-tablets')) || 'tablets'
            }
        };

        var state = {
            shape: 'rectangular',
            length: null,
            width: null,
            diameter: null,
            surface: null,
            depth: 1.2,
            current_ppm: 1.0,
            desired_ppm: 1.5,
            volume: 0
        };

        function persistState() {
            try {
                var payload = {
                    shape: state.shape,
                    length: state.length,
                    width: state.width,
                    diameter: state.diameter,
                    surface: state.surface,
                    depth: state.depth,
                    current_ppm: state.current_ppm,
                    desired_ppm: state.desired_ppm
                };
                localStorage.setItem(storageKey, JSON.stringify(payload));
            } catch (error) {
                // Ignore unavailable storage.
            }
        }

        function restoreState() {
            try {
                var raw = localStorage.getItem(storageKey);
                if (!raw) return;

                var parsed = JSON.parse(raw);
                if (!parsed || typeof parsed !== 'object') return;

                if (parsed.shape && ['rectangular', 'oval', 'circular', 'custom'].indexOf(parsed.shape) !== -1) {
                    state.shape = parsed.shape;
                    shapeInputs.forEach(function (input) {
                        input.checked = input.value === parsed.shape;
                    });
                }

                inputEls.forEach(function (input) {
                    var key = input.getAttribute('data-clc-input');
                    if (!Object.prototype.hasOwnProperty.call(parsed, key)) return;
                    var value = parsed[key];
                    if (value === null || typeof value === 'undefined' || value === '') return;
                    input.value = value;
                    state[key] = getNumber(value);
                });
            } catch (error) {
                // Ignore invalid persisted payload.
            }
        }

        function updateLiveValue(key) {
            var valueEl = root.querySelector('[data-clc-live-value="' + key + '"]');
            if (!valueEl) return;
            var value = state[key];
            valueEl.textContent = value === null ? '—' : formatNumber(value, 1);
        }

        function updateShapeFields() {
            root.querySelectorAll('[data-clc-shape-fields]').forEach(function (group) {
                var shapes = (group.getAttribute('data-clc-shape-fields') || '').split(' ');
                var visible = shapes.indexOf(state.shape) !== -1;
                group.classList.toggle('is-hidden', !visible);
            });
        }

        function syncVolumePreview() {
            state.volume = calcVolume(state);

            if (volumePreview) volumePreview.hidden = state.volume <= 0;
            if (volumeDisplay) {
                volumeDisplay.textContent = state.volume > 0
                    ? formatNumber(state.volume, 1) + ' m³ (' + Math.round(state.volume * 1000) + ' L)'
                    : '—';
            }
        }

        function getIntervalLabel(interval) {
            return config.intervalLabels[interval] || interval;
        }

        function getUnitLabel(unit) {
            var normalizedUnit = String(unit || '').trim().toLowerCase();
            return config.unitLabels[normalizedUnit] || unit;
        }

        function calcDoseResult() {
            if (!config.hasDose || !state.volume) return null;
            if (!config.doseAmount || !config.dosePerVolume) return null;

            var volumeForDose = convertVolumeForDose(state.volume, config.doseVolumeUnit);

            if (!config.hasPpm || !config.dosePpmChange) {
                // Flat dose — no ppm delta needed
                var flatDose = config.doseAmount * (volumeForDose / config.dosePerVolume);
                return {
                    status: 'is-success',
                    message: formatMessage(config.doseFlatTemplate, {
                        amount: '<span class="prc-result__amount">' + escapeHtml(formatNumber(flatDose, 2)) + '</span>',
                        unit: '<span class="prc-result__unit">' + escapeHtml(getUnitLabel(config.doseUnit)) + '</span>'
                    }),
                    isHtml: true
                };
            }

            // ppm-based dose
            if (state.current_ppm === null || state.desired_ppm === null) return null;

            var delta = state.desired_ppm - state.current_ppm;

            if (delta <= 0.000001) {
                return { status: 'is-success', message: config.alreadyInRange, isHtml: false };
            }

            var steps = delta / config.dosePpmChange;
            var dose = steps * config.doseAmount * (volumeForDose / config.dosePerVolume);

            return {
                status: 'is-success',
                message: formatMessage(config.doseTemplate, {
                    target: '<strong class="prc-result__target">' + escapeHtml(formatNumber(state.desired_ppm, 1)) + '</strong>',
                    amount: '<span class="prc-result__amount">' + escapeHtml(formatNumber(dose, 2)) + '</span>',
                    unit: '<span class="prc-result__unit">' + escapeHtml(getUnitLabel(config.doseUnit)) + '</span>'
                }),
                isHtml: true
            };
        }

        function calcMaintenanceResult() {
            if (!config.hasMaintenance || !state.volume) return null;
            if (!config.maintAmount || !config.maintPerVolume) return null;

            var volumeForDose = convertVolumeForDose(state.volume, config.maintVolumeUnit);
            var dose = config.maintAmount * (volumeForDose / config.maintPerVolume);

            return {
                status: 'is-success',
                message: formatMessage(config.maintenanceTemplate, {
                    amount: '<span class="prc-result__amount">' + escapeHtml(formatNumber(dose, 2)) + '</span>',
                    unit: '<span class="prc-result__unit">' + escapeHtml(getUnitLabel(config.maintUnit)) + '</span>',
                    interval: '<span class="clc-result__interval">' + escapeHtml(getIntervalLabel(config.maintInterval)) + '</span>'
                }),
                isHtml: true
            };
        }

        function calcShockResult() {
            if (!config.hasShock || !state.volume) return null;
            if (!config.shockAmount || !config.shockPerVolume) return null;

            var volumeForDose = convertVolumeForDose(state.volume, config.shockVolumeUnit);
            var dose = config.shockAmount * (volumeForDose / config.shockPerVolume);

            return {
                status: 'is-success',
                message: formatMessage(config.shockTemplate, {
                    amount: '<span class="prc-result__amount">' + escapeHtml(formatNumber(dose, 2)) + '</span>',
                    unit: '<span class="prc-result__unit">' + escapeHtml(getUnitLabel(config.shockUnit)) + '</span>'
                }),
                isHtml: true
            };
        }

        function renderResultBlock(type, calcFn) {
            var resultEl = root.querySelector('[data-clc-result="' + type + '"]');
            if (!resultEl) return false;

            var titleEl = resultEl.querySelector('[data-clc-result-title="' + type + '"]');
            var msgEl = resultEl.querySelector('[data-clc-result-message="' + type + '"]');

            var result = calcFn();
            if (!result) {
                resultEl.hidden = true;
                return false;
            }

            resultEl.hidden = false;
            resultEl.classList.remove('is-error', 'is-warning', 'is-success');
            resultEl.classList.add(result.status);

            if (titleEl) titleEl.textContent = config[type + 'TitleText'] || '';
            if (msgEl) {
                if (result.isHtml) {
                    msgEl.innerHTML = result.message;
                } else {
                    msgEl.textContent = result.message;
                }
            }

            return true;
        }

        function renderResults() {
            if (!state.volume || state.volume <= 0) {
                if (resultsContainer) resultsContainer.hidden = true;
                root.querySelectorAll('[data-clc-result]').forEach(function (el) { el.hidden = true; });
                return;
            }

            var anyVisible = false;
            if (renderResultBlock('dose', calcDoseResult)) anyVisible = true;
            if (renderResultBlock('maintenance', calcMaintenanceResult)) anyVisible = true;
            if (renderResultBlock('shock', calcShockResult)) anyVisible = true;

            if (resultsContainer) resultsContainer.hidden = !anyVisible;
        }

        shapeInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                state.shape = input.value;
                updateShapeFields();
                syncVolumePreview();
                renderResults();
                persistState();
            });
        });

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-clc-input');
            state[key] = getNumber(input.value);
            updateLiveValue(key);

            function handleValueChange() {
                state[key] = getNumber(input.value);

                var isPpmField = key === 'current_ppm' || key === 'desired_ppm';
                var isInvalid = false;

                if (state[key] === null) {
                    isInvalid = !isPpmField;
                } else if (!isPpmField && state[key] <= 0) {
                    isInvalid = true;
                } else if (isPpmField && state[key] !== null && state[key] < 0) {
                    isInvalid = true;
                }

                if (isInvalid) {
                    input.classList.add('is-invalid');
                } else {
                    input.classList.remove('is-invalid');
                }

                updateLiveValue(key);
                syncVolumePreview();
                renderResults();
                persistState();
            }

            input.addEventListener('input', handleValueChange);
            input.addEventListener('change', handleValueChange);
        });

        restoreState();

        inputEls.forEach(function (input) {
            var key = input.getAttribute('data-clc-input');
            if (state[key] !== null && typeof state[key] !== 'undefined') {
                input.value = state[key];
            }
            updateLiveValue(key);
        });

        updateShapeFields();
        syncVolumePreview();
        renderResults();
    });
})();
